import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63e00c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-light bg-light static-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "navbar-brand",
  href: "/"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = {
  class: "btn btn-sm dropdown-toggle",
  type: "button",
  id: "languageDropdown",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "dropdown-menu bg-light",
  "aria-labelledby": "languageDropdown"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "masthead" }
const _hoisted_12 = { class: "container position-relative" }
const _hoisted_13 = { class: "row justify-content-center" }
const _hoisted_14 = { class: "col-xl-6" }
const _hoisted_15 = { class: "text-center text-white" }
const _hoisted_16 = { class: "mb-5" }
const _hoisted_17 = { class: "lead mb-5" }
const _hoisted_18 = { class: "features-icons bg-light text-center" }
const _hoisted_19 = { class: "container" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-4" }
const _hoisted_22 = { class: "features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "features-icons-icon d-flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-lightbulb m-auto text-secondary" })
], -1))
const _hoisted_24 = { class: "lead mb-0" }
const _hoisted_25 = { class: "col-lg-4" }
const _hoisted_26 = { class: "features-icons-item mx-auto mb-5 mb-lg-0 mb-lg-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "features-icons-icon d-flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-graph-up m-auto text-secondary" })
], -1))
const _hoisted_28 = { class: "lead mb-0" }
const _hoisted_29 = { class: "col-lg-4" }
const _hoisted_30 = { class: "features-icons-item mx-auto mb-0 mb-lg-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "features-icons-icon d-flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-wrench m-auto text-secondary" })
], -1))
const _hoisted_32 = { class: "lead mb-0" }
const _hoisted_33 = { class: "showcase" }
const _hoisted_34 = { class: "container-fluid p-0" }
const _hoisted_35 = { class: "row g-0" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 order-md-1" }, null, -1))
const _hoisted_37 = { class: "col-lg-3 my-auto order-md-2 order-2 showcase-text oval-shape teal-bg" }
const _hoisted_38 = { class: "title-text mt-1" }
const _hoisted_39 = { class: "lead mb-0 content-text mt-4" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 order-md-3" }, null, -1))
const _hoisted_41 = { class: "col-lg-6 order-md-4 order-1 text-white showcase-img" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "row g-0" }
const _hoisted_44 = { class: "col-lg-6 order-1 text-white showcase-img" }
const _hoisted_45 = ["src"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 order-md-2" }, null, -1))
const _hoisted_47 = { class: "col-lg-3 order-md-3 order-2 my-auto showcase-text oval-shape deep-sea-blue-bg" }
const _hoisted_48 = { class: "title-text mt-1" }
const _hoisted_49 = { class: "lead mb-0 mt-4" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 order-md-4" }, null, -1))
const _hoisted_51 = { class: "row g-0" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2 order-md-1" }, null, -1))
const _hoisted_53 = { class: "col-lg-3 my-auto order-md-2 order-2 showcase-text oval-shape greenish-gray-bg" }
const _hoisted_54 = { class: "title-text mt-2" }
const _hoisted_55 = { class: "lead mb-0 mt-4" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 order-md-3" }, null, -1))
const _hoisted_57 = { class: "col-lg-6 order-md-last order-md-4 order-1 text-white showcase-img" }
const _hoisted_58 = ["src"]
const _hoisted_59 = { class: "testimonials text-center bg-light" }
const _hoisted_60 = { class: "container" }
const _hoisted_61 = { class: "mb-5" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-lg-4" }
const _hoisted_64 = { class: "mx-auto mb-5 mb-lg-0" }
const _hoisted_65 = ["src"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Grad Umag", -1))
const _hoisted_67 = { class: "font-weight-light mb-0" }
const _hoisted_68 = { class: "col-lg-4" }
const _hoisted_69 = { class: "mx-auto mb-5 mb-lg-0" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-fluid mb-3 bg-dark",
  src: "https://majresidence.com/img/logo-maj.svg",
  alt: "Maj Residence",
  style: {"width":"28%"}
}, null, -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Maj Residence", -1))
const _hoisted_72 = { class: "font-weight-light mb-0" }
const _hoisted_73 = {
  class: "call-to-action text-white text-center",
  id: "signup"
}
const _hoisted_74 = { class: "container position-relative" }
const _hoisted_75 = { class: "row justify-content-center" }
const _hoisted_76 = { class: "col-xl-6" }
const _hoisted_77 = { class: "mb-4" }
const _hoisted_78 = {
  class: "form-subscribe",
  id: "contactFormFooter",
  "data-sb-form-api-token": "API_TOKEN"
}
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-12" }
const _hoisted_81 = {
  class: "d-none",
  id: "submitSuccessMessage"
}
const _hoisted_82 = { class: "text-center mb-3" }
const _hoisted_83 = { class: "fw-bolder" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "text-white",
  href: "https://startbootstrap.com/solution/contact-forms"
}, "https://startbootstrap.com/solution/contact-forms", -1))
const _hoisted_85 = {
  class: "d-none",
  id: "submitErrorMessage"
}
const _hoisted_86 = { class: "text-center text-danger mb-3" }
const _hoisted_87 = { class: "footer bg-light" }
const _hoisted_88 = { class: "container" }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-lg-6 h-100 text-center text-lg-start my-auto" }
const _hoisted_91 = { class: "list-inline mb-2" }
const _hoisted_92 = { class: "list-inline-item" }
const _hoisted_93 = {
  href: "https://tri-m.hr/?p=o-nama",
  target: "_blank"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list-inline-item" }, "⋅", -1))
const _hoisted_95 = { class: "list-inline-item" }
const _hoisted_96 = {
  href: "https://tri-m.hr/?p=kontakt",
  target: "_blank"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted small mb-4 mb-lg-0" }, "© ECabinet 2023. All Rights Reserved.", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 h-100 text-center text-lg-end my-auto" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "list-inline mb-0" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createElementVNode("img", {
            src: require('../assets/LogoTriM.png'),
            alt: "Logo",
            width: "85",
            class: "d-inline-block align-text-top"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t.language) + " ", 1),
            _createElementVNode("img", {
              src: _ctx.selectedImage,
              width: "30",
              class: "img-fluid"
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "dropdown-item",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('en')))
            }, [
              _createElementVNode("img", {
                src: require('../assets/lang/en.svg'),
                alt: "English",
                width: "30",
                class: "img-fluid"
              }, null, 8, _hoisted_9),
              _createTextVNode(" " + _toDisplayString(_ctx.$t.english), 1)
            ]),
            _createElementVNode("button", {
              class: "dropdown-item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('hr')))
            }, [
              _createElementVNode("img", {
                src: require('../assets/lang/hr.svg'),
                alt: "Croatian",
                width: "30",
                class: "img-fluid"
              }, null, 8, _hoisted_10),
              _createTextVNode(" " + _toDisplayString(_ctx.$t.croatian), 1)
            ])
          ])
        ]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.login())),
          class: "btn btn-outline-secondary"
        }, _toDisplayString(_ctx.$t.login), 1)
      ])
    ]),
    _createElementVNode("header", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.$t.discoverFuture), 1),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t.harnessPower), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t.smartControl), 1),
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t.tailoredIoTSolutions), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t.dataAnalytics), 1),
              _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t.useAppAnalytics), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t.infrastructureManagement), 1),
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t.manageIoTInfrastructure), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("h2", _hoisted_38, _toDisplayString(_ctx.$t.smartCities), 1),
            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t.ourSolutionFacilitates), 1)
          ]),
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("img", {
              class: "img-fluid",
              src: require('../assets/smartCity_2.jpg'),
              alt: "..."
            }, null, 8, _hoisted_42)
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("img", {
              class: "img-fluid",
              src: require('../assets/smartCamp_1.jpg'),
              alt: "..."
            }, null, 8, _hoisted_45)
          ]),
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("h2", _hoisted_48, _toDisplayString(_ctx.$t.smartCamps), 1),
            _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t.improveOrganization), 1)
          ]),
          _hoisted_50
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("h2", _hoisted_54, _toDisplayString(_ctx.$t.smartInfrastructure), 1),
            _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t.enhanceInfrastructureProjects), 1)
          ]),
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("img", {
              class: "img-fluid",
              src: require('../assets/smartInfrastructure_3.png'),
              alt: "..."
            }, null, 8, _hoisted_58)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_59, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("h2", _hoisted_61, _toDisplayString(_ctx.$t.meetOurClients), 1),
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("img", {
                class: "img-fluid mb-3",
                src: require('../assets/gradUmag.png'),
                alt: "Grad Umag"
              }, null, 8, _hoisted_65),
              _hoisted_66,
              _createElementVNode("p", _hoisted_67, "\"" + _toDisplayString(_ctx.$t.efficientlyManagingCityLights) + "\"", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _hoisted_71,
              _createElementVNode("p", _hoisted_72, "\"" + _toDisplayString(_ctx.$t.enjoyingFlawlessPowerControl) + "\"", 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_73, [
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("h2", _hoisted_77, _toDisplayString(_ctx.$t.readyToGetStarted), 1),
            _createElementVNode("form", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.redirectToRegistration()), ["prevent"])),
                    class: "btn btn-outline-info btn-lg register-button",
                    id: "submitButton",
                    type: "submit"
                  }, _toDisplayString(_ctx.$t.register), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t.formSubmissionSuccessful), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t.toActivateThisForm), 1),
                  _hoisted_84
                ])
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.$t.errorSendingMessage), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_87, [
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("ul", _hoisted_91, [
              _createElementVNode("li", _hoisted_92, [
                _createElementVNode("a", _hoisted_93, _toDisplayString(_ctx.$t.about), 1)
              ]),
              _hoisted_94,
              _createElementVNode("li", _hoisted_95, [
                _createElementVNode("a", _hoisted_96, _toDisplayString(_ctx.$t.contact), 1)
              ])
            ]),
            _hoisted_97
          ]),
          _hoisted_98
        ])
      ])
    ])
  ], 64))
}